import { useCallback, useMemo } from 'react'
import {
  baseMathematicsId,
  foreignLanguageId,
} from '@ucheba/store/ege/subjects/constants'
import { IUseFormSelectEgeCore } from './types'

export const useFormSelectEgeCore: IUseFormSelectEgeCore = ({
  onSubmit,
  egeList,
  value = [],
  name,
}) => {
  const initialValues = useMemo(
    () => ({
      [name]: value,
    }),
    [name, value]
  )

  /* Сабмит формы прокидывает ее значения в колбэк */
  const onSubmitForm = useCallback((values) => onSubmit(values[name]), [name, onSubmit])

  /* Подготавливаем список егэ */
  const egeListPrepared = useMemo(() => {
    let hasForeign = false

    return egeList
      .filter(({ id, parent }) => {
        let notNeedFilter = id !== baseMathematicsId

        if (parent?.id === foreignLanguageId) {
          notNeedFilter = !hasForeign

          hasForeign = true
        }

        return notNeedFilter
      })
      .map((ege) =>
        ege.parent && ege.parent.id === foreignLanguageId ? ege.parent : ege
      )
  }, [egeList])

  return {
    initialValues,
    onSubmitForm,
    egeListPrepared,
  }
}
